export class Annotation {
    annotation: string;
    start: number;
    user: number;
    datatype: number;
    record: number;
}
